import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'snackbarMarkupPipe'
})
export class SnackbarMarkupPipe implements PipeTransform {
  transform(value: unknown): string {
    if (typeof value !== 'string') {
      return `${value ?? ''}`;
    }

    return value.replace(/\[br\]/g, '\n');
  }
}
